module.exports = __webpack_public_path__ + "img/noContent.335a4489.gif";